import { useQuery } from '@tanstack/react-query';
import { useSendbirdStateContext } from "@sendbird/uikit-react";

export const useGroupChannelCount = () => {
  const { stores: { sdkStore: { sdk } } } = useSendbirdStateContext();

  return useQuery({
    queryKey: ['groupChannelCount'],
    queryFn: async () => {
      if (!sdk?.groupChannel?.createMyGroupChannelListQuery) return 0;
      
      const query = sdk.groupChannel.createMyGroupChannelListQuery({
        customTypesFilter: ['group']
      });
      
      const channels = await query.next();
      return channels?.length || 0;
    },
    enabled: !!sdk?.groupChannel,
    staleTime: 5 * 60 * 1000,
  });
};